// payload is optional you have ability to send props to fetchTeamDefinitionData
import settingsRequests from '@/http/requests/settings/settings'

export default {
  fetchTeamDefinitions: ({ commit }, payload) => new Promise((resolve, reject) => {
    settingsRequests.getTeamDefinitions(payload)
      .then(response => {
        commit('SET_TEAM_DEFINITIONS_DATA', response.data.items)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  fetchFreeTeamDefinitions: ({ commit }, payload) => new Promise((resolve, reject) => {
    settingsRequests.getFreeTeamDefinitions(payload)
      .then(response => {
        commit('SET_FREE_TEAM_DEFINITIONS_DATA', response.data)
        resolve(response.data)
      })
      .catch(err => reject(err))
  }),
  fetchTeamDefinitionData: ({ commit }, id) => new Promise((resolve, reject) => {
    settingsRequests.getTeamDefinition(id)
      .then(response => {
        commit('SET_TEAM_DEFINITION_DATA', response.data)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  addTeamDefinition: (_, payload) => new Promise((resolve, reject) => {
    settingsRequests.addTeamDefinition(payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  updateTeamDefinition: ({ commit }, payload) => new Promise((resolve, reject) => {
    settingsRequests.updateTeamDefinition(payload.id, payload.data)
      .then(response => {
        commit('SET_TEAM_DEFINITION_DATA', payload.data)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  fetchChecklistDictionaries: ({ commit }, payload) => new Promise((resolve, reject) => {
    settingsRequests.getChecklistDictionaries(payload)
      .then(response => {
        commit('SET_CHECKLIST_DICTIONARIES_DATA', response.data.items)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  searchChecklistItems: (_, query) => new Promise((resolve, reject) => {
    settingsRequests.getChecklistDictionaries({ q: query })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  fetchFreeChecklistDictionaries: ({ commit }, payload) => new Promise((resolve, reject) => {
    settingsRequests.getFreeChecklistDictionaries(payload)
      .then(response => {
        commit('SET_FREE_CHECKLIST_DICTIONARIES_DATA', response.data)
        resolve(response.data)
      })
      .catch(err => reject(err))
  }),
  fetchChecklistDictionaryData: ({ commit }, id) => new Promise((resolve, reject) => {
    settingsRequests.getChecklistDictionary(id)
      .then(response => {
        commit('SET_CHECKLIST_DICTIONARY_DATA', response.data)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  addChecklistDictionary: (_, payload) => new Promise((resolve, reject) => {
    settingsRequests.addChecklistDictionary(payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  updateChecklistDictionary: ({ commit }, payload) => new Promise((resolve, reject) => {
    settingsRequests.updateChecklistDictionary(payload.id, payload.data)
      .then(response => {
        commit('SET_CHECKLIST_DICTIONARY_DATA', payload.data)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
}
